import { useState, useEffect } from "react";
import Modal from "./Modal";
import BottomSheet from "./BottomSheet";

import useDeviceSize from "src/hooks/useDeviceSize";

import { findAllSuggestDesc } from "src/api/quotationDraft";

const ModalAddition = ({
  type = "desc",
  descData = "",
  docType,
  isOpen,
  isEdit,
  onClose,
  onSubmit,
}) => {
  const [dataSearch, setDataSearch] = useState({
    type: "",
    filter: null,
  });
  const [suggestDescList, setSuggestDescList] = useState([]);
  const [deviceWidth] = useDeviceSize();

  // set data search
  useEffect(() => {
    setDataSearch({
      type: docType,
      filter: docType === "product" && !isEdit ? "floor" : null,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOpen]);

  useEffect(() => {
    if (dataSearch.type === "") return;

    (async () => {
      const { data } = await findAllSuggestDesc(dataSearch);
      if (data.length > 0) {
        setSuggestDescList(
          data?.length > 0
            ? data.map((item) => ({
                ...item,
                isSelect: false,
              }))
            : [],
        );
      }
    })();
  }, [dataSearch]);

  return (
    <>
      {deviceWidth > 835 ? (
        <Modal
          type={type}
          descData={descData}
          docType={docType}
          dataSearch={dataSearch}
          setDataSearch={setDataSearch}
          suggestDescList={suggestDescList}
          setSuggestDescList={setSuggestDescList}
          isOpen={isOpen}
          isEdit={isEdit}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      ) : (
        <BottomSheet
          type={type}
          descData={descData}
          docType={docType}
          dataSearch={dataSearch}
          setDataSearch={setDataSearch}
          suggestDescList={suggestDescList}
          setSuggestDescList={setSuggestDescList}
          isOpen={isOpen}
          isEdit={isEdit}
          onClose={onClose}
          onSubmit={onSubmit}
        />
      )}
    </>
  );
};

export default ModalAddition;
